let binaryData = [];

binaryData = [
        {
            title: "Khan Academy",
            description: "Learn some more about binary and how computers store information with Khan Academy.",
            link: "https://www.khanacademy.org/computing/computers-and-internet/xcae6f4a7ff015e7d:digital-information"
        },
        {
            title: "Math is Fun",
            description: "Learn more about different number systems with Math is Fun!",
            link: "https://www.mathsisfun.com/binary-number-system.html"
        },
        {
            title: "BBC",
            description: "Learn about the binary number system with the BBC!",
            link: "https://www.bbc.co.uk/bitesize/topics/zgv8dp3/articles/z9j2jsg"
        }
    ]


export default binaryData;
